import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=2ec467f8&scoped=true"
import script from "./ExamDetail.vue?vue&type=script&lang=js"
export * from "./ExamDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=2ec467f8&prod&scoped=true&lang=css"
import style1 from "./ExamDetail.vue?vue&type=style&index=1&id=2ec467f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec467f8",
  null
  
)

export default component.exports